import { Plus, Trash, X, ChevronsUpDown } from 'lucide-react';
import { EmbalajesModal, getEmbalajes } from './EmbalajesModal';

export const PackagesTableContent = ({
  declarationIndex,
  itemIndex,
  isSpanish,
  item,
  editableData,
  setEditableData,
  setIsDirty,
  embalajesModalOpen,
  setEmbalajesModalOpen,
  currentEmbalajeIndex,
  setCurrentEmbalajeIndex,
}) => {
  const embalajes = getEmbalajes();

  const handleEmbalajeChange = (declarationIndex, itemIndex, embajaIndex, field, value) => {
    // Deep clone to avoid mutating original data
    const updatedData = JSON.parse(JSON.stringify(editableData));
    if (updatedData[declarationIndex].partidas &&
      updatedData[declarationIndex].partidas[itemIndex] &&
      updatedData[declarationIndex].partidas[itemIndex].embalajes &&
      updatedData[declarationIndex].partidas[itemIndex].embalajes[embajaIndex]) {
      updatedData[declarationIndex].partidas[itemIndex].embalajes[embajaIndex][field] = value;
      setEditableData(updatedData);
      setIsDirty(true);
    }
  };

  const handleMarcaChange = (declarationIndex, itemIndex, embajaIndex, marcaIndex, value) => {
    // Deep clone to avoid mutating original data
    const updatedData = JSON.parse(JSON.stringify(editableData));
    if (updatedData[declarationIndex].partidas &&
      updatedData[declarationIndex].partidas[itemIndex] &&
      updatedData[declarationIndex].partidas[itemIndex].embalajes &&
      updatedData[declarationIndex].partidas[itemIndex].embalajes[embajaIndex] &&
      updatedData[declarationIndex].partidas[itemIndex].embalajes[embajaIndex].marcas &&
      updatedData[declarationIndex].partidas[itemIndex].embalajes[embajaIndex].marcas[marcaIndex]) {
      updatedData[declarationIndex].partidas[itemIndex].embalajes[embajaIndex].marcas[marcaIndex].marca = value;
      setEditableData(updatedData);
      setIsDirty(true);
    }
  };

  const handleEmbalajeSelect = (selectedEmbalaje) => {
    if (currentEmbalajeIndex !== null) {
      handleEmbalajeChange(declarationIndex, itemIndex, currentEmbalajeIndex, 'tipo', selectedEmbalaje.codigo);
    }
    setEmbalajesModalOpen(false);
    setCurrentEmbalajeIndex(null);
  };

  const getSelectedEmbalaje = (tipo) => {
    return embalajes.find(embalaje => embalaje.codigo === tipo);
  };

  return (
    <div className="overflow-auto">
      <table className="min-w-full border-collapse text-sm">
        <thead>
          <tr>
          <th className="py-2 px-4 pt-2 pl-0">
              <p className="w-max">#</p>
            </th>
            <th className="py-2 px-4 pt-2"><p className='w-max'>{!isSpanish ? "Type" : "Tipo"}</p></th>
            <th className="py-2 px-4 pt-2"><p className='w-max'>{!isSpanish ? "Quantity" : "Cantidad"}</p></th>
            <th className="py-2 px-4 pt-2"><p className='w-max'>{!isSpanish ? "Remaining Quantity" : "Cantidad Restante"}</p></th>
            <th className="py-2 px-4 pt-2"><p className='w-max'>{!isSpanish ? "Pieces" : "Piezas"}</p></th>
            <th className="py-2 px-4 pt-2"><p className='w-max'>{!isSpanish ? "Internal or External" : "Es Interno o Externo"}</p></th>
            <th className="py-2 px-4 pt-2"><p className='w-max'>{!isSpanish ? "Marks" : "Marcas"}</p></th>
            <th className="py-2 px-4 pt-2"></th>
          </tr>
        </thead>
        <tbody>
          {item.embalajes?.map((embalaje, embajaIndex) => (
            <tr key={embajaIndex}>
              <td className="py-4 px-4 border-t pl-0">
                <span className="text-sm">{embajaIndex + 1}</span>
              </td>
              <td className="py-4 px-4 border-t">
                <div className="relative w-full">
                  <button
                    type="button"
                    id={`packages_tipo_${declarationIndex + 1}_${itemIndex}_${embajaIndex}`}
                    className={`w-full flex gap-2 justify-between items-center custom-dropwdown text-sm py-1 ${
                      getSelectedEmbalaje(embalaje.tipo) ? "" : "opacity-75"
                    }`}
                    onClick={() => {
                      setCurrentEmbalajeIndex(embajaIndex);
                      setEmbalajesModalOpen(true);
                    }}
                  >
                    {getSelectedEmbalaje(embalaje.tipo) ? (
                      <span className="truncate">
                        {getSelectedEmbalaje(embalaje.tipo).codigo}{" "}
                        {getSelectedEmbalaje(embalaje.tipo).nombre && (
                          <span className="text-xs text-gray-400 ml-2">
                            ({getSelectedEmbalaje(embalaje.tipo).nombre})
                          </span>
                        )}
                      </span>
                    ) : embalaje.tipo ? (
                      <span className="truncate" title={embalaje.tipo}>
                        {embalaje.tipo}
                      </span>
                    ) : (
                      <span className="truncate">
                        {!isSpanish
                          ? "Select Package Type"
                          : "Seleccionar Tipo de Embalaje"}
                      </span>
                    )}
                    <ChevronsUpDown className="w-4 h-4" />
                  </button>
                </div>
              </td>
              <td className="py-4 px-4 border-t">
                <input
                  id={`packages_cantidad_${declarationIndex + 1}_${itemIndex}_${embajaIndex}`}
                  value={embalaje.cantidad || ''}
                  placeholder={`${!embalaje.cantidad && !isSpanish ? "Enter Quantity" : "Entrada Cantidad"}`}
                  onChange={(e) => handleEmbalajeChange(declarationIndex, itemIndex, embajaIndex, 'cantidad', e.target.value)}
                  className="w-full border rounded px-2 py-1"
                />
              </td>
              <td className="py-4 px-4 border-t">
                <input
                  id={`packages_cantidad_restante_${declarationIndex + 1}_${itemIndex}_${embajaIndex}`}
                  value={embalaje?.cantidad_restante || ''}
                  type='number'
                  placeholder={`${!embalaje.cantidad_restante && !isSpanish ? "Enter Remaining Quantity" : "Entrada Cantidad Restante"}`}
                  onChange={(e) => handleEmbalajeChange(declarationIndex, itemIndex, embajaIndex, 'cantidad_restante', parseInt(e.target.value))}
                  className="w-full border rounded px-2 py-1"
                />
              </td>
              <td className="py-4 px-4 border-t">
                <input
                  id={`packages_piezas_${declarationIndex + 1}_${itemIndex}_${embajaIndex}`}
                  value={embalaje?.piezas || ''}
                  placeholder={`${!embalaje.piezas && !isSpanish ? "Enter Pieces" : "Entrada Piezas"}`}
                  onChange={(e) => handleEmbalajeChange(declarationIndex, itemIndex, embajaIndex, 'piezas', e.target.value)}
                  className="w-full border rounded px-2 py-1"
                />
              </td>
              <td className="py-4 px-4 border-t">
                <input
                  value={embalaje.es_interno_o_externo || ''}
                  placeholder={`${!embalaje.es_interno_o_externo && !isSpanish ? "Enter Internal or External" : "Entrada Es Interno o Externo"}`}
                  onChange={(e) => handleEmbalajeChange(declarationIndex, itemIndex, embajaIndex, 'es_interno_o_externo', e.target.value)}
                  className={`w-full border rounded px-2 py-1 ${!embalaje.es_interno_o_externo && 'required-input'}`}
                  id={`packages_es_interno_o_externo_${declarationIndex + 1}_${itemIndex}_${embajaIndex}`}
                  required
                />
              </td>
              <td className="py-4 px-4 border-t" id={`packages_marcas_${declarationIndex + 1}_${itemIndex}_${embajaIndex}`}>
                <div className='w-fit flex flex-col gap-1'>
                  {embalaje.marcas?.map((marca, marcaIndex) => (
                    <div key={marcaIndex} className="flex items-center gap-2">
                      <input
                        value={marca.marca || ''}
                        placeholder={`${!marca.marca && !isSpanish ? "Enter Mark" : "Entrada Marca"}`}
                        onChange={(e) => handleMarcaChange(declarationIndex, itemIndex, embajaIndex, marcaIndex, e.target.value)}
                        className={`min-w-20 border rounded px-2 py-1 ${!marca.marca && 'required-input'}`}
                        id={`packages_marcas_marca_${declarationIndex + 1}_${itemIndex}_${embajaIndex}_${marcaIndex}`}
                        required
                      />
                      <button
                        className="text-red-500"
                        onClick={() => {
                          const updatedData = [...editableData];
                          updatedData[declarationIndex].partidas[itemIndex].embalajes[embajaIndex].marcas.splice(marcaIndex, 1);
                          setEditableData(updatedData);
                          setIsDirty(true);
                        }}
                      >
                        <X className="size-4 stroke-red-500 mt-1" />
                      </button>
                    </div>
                  ))}
                  <button
                    className="text-xs flex items-center gap-1 mt-1 w-max"
                    onClick={() => {
                      const updatedData = [...editableData];
                      if (!updatedData[declarationIndex].partidas[itemIndex].embalajes[embajaIndex].marcas) {
                        updatedData[declarationIndex].partidas[itemIndex].embalajes[embajaIndex].marcas = [];
                      }
                      updatedData[declarationIndex].partidas[itemIndex].embalajes[embajaIndex].marcas.push({
                        marca: ""
                      });
                      setEditableData(updatedData);
                      setIsDirty(true);
                    }}
                  >
                    <Plus className="size-4" />
                    {isSpanish ? "Agregar Marca" : "Add Mark"}
                  </button>
                </div>
              </td>
              <td className="py-4 px-4 border-t">
                <button
                  className="py-1 text-xs flex items-center gap-1 text-red-500"
                  onClick={() => {
                    const updatedData = [...editableData];
                    updatedData[declarationIndex].partidas[itemIndex].embalajes.splice(embajaIndex, 1);
                    setEditableData(updatedData);
                    setIsDirty(true);
                  }}
                >
                  <Trash className={`size-4 stroke-red-500`} />
                  {isSpanish ? "Eliminar" : "Delete"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <EmbalajesModal
        embalajes={embalajes}
        isOpen={embalajesModalOpen}
        onClose={() => {
          setEmbalajesModalOpen(false);
          setCurrentEmbalajeIndex(null);
        }}
        onSelect={handleEmbalajeSelect}
        selectedEmbalaje={currentEmbalajeIndex !== null ? getSelectedEmbalaje(item.embalajes?.[currentEmbalajeIndex]?.tipo) : null}
        title={!isSpanish ? "Select Package Type" : "Seleccionar Tipo de Embalaje"}
      />
    </div>
  );
};

